import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SessionCtx = createContext(null);
export const useSession = () => useContext(SessionCtx);

export const SessionProvider = ({ children }) => {
  const [config, setConfig] = useState(null);
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const signOut = useCallback(() => {
    localStorage.removeItem("mt_token");
    localStorage.removeItem("mt_org");
    setSession(null);
  }, []);

  const verify = useCallback(async (orgId) => {
    const res = await api.post("/sso/verify", { org_id: orgId || null });
    localStorage.setItem("mt_org", res.data.org_id);
    setSession(res.data);
    return res.data;
  }, []);

  const signIn = useCallback((token, ctx) => {
    localStorage.setItem("mt_token", token);
    localStorage.setItem("mt_org", ctx.org_id);
    setSession(ctx);
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const c = await api.get("/config");
        setConfig(c.data);
        if (localStorage.getItem("mt_token")) await verify(localStorage.getItem("mt_org"));
      } catch (e) {
        if (e?.response?.status === 401) signOut();
        else if (localStorage.getItem("mt_token")) setError("We couldn't reach Morr Access. Try again in a moment.");
      } finally {
        setLoading(false);
      }
    })();
  }, [verify, signOut]);

  const switchOrg = async (orgId) => {
    localStorage.setItem("mt_org", orgId);
    await verify(orgId);
  };

  return (
    <SessionCtx.Provider value={{ config, session, loading, error, signIn, signOut, switchOrg, verify }}>
      {children}
    </SessionCtx.Provider>
  );
};
